export default "__VITE_ASSET__BC5BCwts__"